import React from 'react'
import { useTranslation } from 'react-i18next'
import { CardEmptyState } from 'ui_elements/CardEmptyState/CardEmptyState'

export const GlobalSearchNoResultsState = () => {
  const { t } = useTranslation('global_search')

  return (
    <CardEmptyState
      header={t('global_search:NoResultsState.header', 'No results found')}
      horizontal={false}
      message={t(
        'global_search:NoResultsState.message',
        'You may want to try different keywords or check for any possible typos.'
      )}
      noBorder
    />
  )
}
